<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Legend" });
import { t } from "svelte-i18n";
export let label;
export let isDisabled = false;
</script>

{#if label !== null}
    <legend class:s8-disabled = { isDisabled }>
        {#if label !== undefined}
            { $t(label) }
        {/if}
    </legend>
{/if}

<style>

    legend {
        font-size: 9px;
        line-height: 10px;
    }

        legend.s8-disabled {
            color: rgba(39,39,17,0.24);
        }</style>